import { Observable } from "rxjs";
import { IMPERSONATION } from "constants/action-types";
import siteConfig from "site-config";
import { formatMessage } from "lib/globalize-util";
import { ajax } from "lib/observable";
import "rxjs/add/operator/map";
import { add as snackbarAdd } from "../../actions/snackbars";

export const fetchImpersonationCodeEpic = (action$, store) => {
    return action$
        .ofType(IMPERSONATION.REQUEST_IMPERSONATION.FETCH.START)
        .map((action) => {
            return action.payload;
        })
        .concatMap(() => {
            return ajax({
                method: "GET",
                url: `${siteConfig.api}/user/request-impersonation`,
            })
                .map(({ response, status }) => {
                    if (response && status === 200) {
                        return { result: response, error: false, status };
                    } else {
                        return { error: true, result: {}, status };
                    }
                })
                .flatMap(({ result, error, status }) => {
                    if (error) {
                        return [
                            store.dispatch(
                                snackbarAdd({ message: formatMessage("Error fetching impersonation code") })
                            ),
                            {
                                payload: result,
                                error: true,
                                type: IMPERSONATION.REQUEST_IMPERSONATION.FETCH.COMPLETED,
                            },
                        ];
                    } else {
                        return [
                            {
                                payload: result,
                                error: false,
                                type: IMPERSONATION.REQUEST_IMPERSONATION.FETCH.COMPLETED,
                            },
                        ];
                    }
                })
                .catch((error) => {
                    const errorMessage = formatMessage("Error fetching impersonation code");

                    if (error && error.status === 404) {
                        return Observable.merge(
                            Observable.of({
                                error: true,
                                type: IMPERSONATION.REQUEST_IMPERSONATION.FETCH.COMPLETED,
                            }),
                            Observable.of(snackbarAdd({ message: errorMessage }))
                        );
                    } else {
                        return Observable.merge(
                            Observable.of({
                                error: true,
                                payload: new Error(errorMessage),
                                type: IMPERSONATION.REQUEST_IMPERSONATION.FETCH.COMPLETED,
                            }),
                            Observable.of(snackbarAdd({ message: errorMessage }))
                        );
                    }
                });
        });
};

export const fetchImpersonationTokenEpic = (action$, store) => {
    return action$
        .ofType(IMPERSONATION.ENTER_IMPERSONATION.CREATE.START)
        .map((action) => {
            return action.payload;
        })
        .concatMap((userData) => {
            return ajax({
                method: "POST",
                body: {
                    ...userData,
                },
                url: `${siteConfig.api}/user/impersonation-token`,
                handle401: true,
            })
                .map(({ response, status }) => {
                    if (response && status === 200) {
                        return { result: response, error: false, status };
                    } else {
                        return { error: true, result: {}, status };
                    }
                })
                .flatMap(({ result, error, status }) => {
                    if (error) {
                        return [
                            snackbarAdd({ message: formatMessage("Error fetching impersonation token") }),
                            {
                                payload: result,
                                error: true,
                                type: IMPERSONATION.ENTER_IMPERSONATION.CREATE.COMPLETED,
                            },
                        ];
                    } else {
                        return [
                            {
                                payload: result,
                                error: false,
                                type: IMPERSONATION.ENTER_IMPERSONATION.CREATE.COMPLETED,
                            },
                        ];
                    }
                })
                .catch((error) => {
                    const errorMessage = formatMessage("Error fetching impersonation token");

                    if (error && error.status === 404) {
                        return Observable.merge(
                            Observable.of({
                                error: true,
                                type: IMPERSONATION.ENTER_IMPERSONATION.CREATE.COMPLETED,
                            }),
                            Observable.of(snackbarAdd({ message: errorMessage }))
                        );
                    } else {
                        return Observable.merge(
                            Observable.of({
                                error: true,
                                payload: new Error(errorMessage),
                                type: IMPERSONATION.ENTER_IMPERSONATION.CREATE.COMPLETED,
                            }),
                            Observable.of(snackbarAdd({ message: errorMessage }))
                        );
                    }
                });
        });
};

export const stopImpersonationEpic = (action$, store) => {
    return action$
        .ofType(IMPERSONATION.STOP_IMPERSONATION.FETCH.START)
        .map((action) => {
            return action.payload;
        })
        .concatMap(() => {
            return ajax({
                method: "GET",
                url: `${siteConfig.api}/user/stop-impersonation`,
            })
                .map(({ response, status }) => {
                    if (response && status === 200) {
                        return { result: response, error: false, status };
                    } else {
                        return { error: true, result: {}, status };
                    }
                })
                .flatMap(({ result, error, status }) => {
                    if (error) {
                        return [
                            snackbarAdd({ message: formatMessage("Error fetching impersonation code") }),
                            {
                                payload: result,
                                error: true,
                                type: IMPERSONATION.STOP_IMPERSONATION.FETCH.COMPLETED,
                            },
                        ];
                    } else {
                        return [
                            {
                                payload: result,
                                error: false,
                                type: IMPERSONATION.STOP_IMPERSONATION.FETCH.COMPLETED,
                            },
                        ];
                    }
                })
                .catch((error) => {
                    const errorMessage = formatMessage("Error fetching impersonation code");

                    if (error && error.status === 404) {
                        return Observable.merge(
                            Observable.of({
                                error: true,
                                type: IMPERSONATION.STOP_IMPERSONATION.FETCH.COMPLETED,
                            }),
                            Observable.of(snackbarAdd({ message: errorMessage }))
                        );
                    } else {
                        return Observable.merge(
                            Observable.of({
                                error: true,
                                payload: new Error(errorMessage),
                                type: IMPERSONATION.STOP_IMPERSONATION.FETCH.COMPLETED,
                            }),
                            Observable.of(snackbarAdd({ message: errorMessage }))
                        );
                    }
                });
        });
};
